import { GetValuesRender } from './commonViews';

import React from 'react';
import PropTypes from 'prop-types';

const NotificationView = props => {
    const { data } = props;
    const { multipleEmails } = data;
    const simpleFields = (({ multipleEmails, ...rest }) => rest)(data);

    return (
        <>
            <div className="checker-section-container">
                <h1 className="checker-section-title">
                    Notification Section Data
                </h1>

                <div className="form-section">
                    <GetValuesRender data={simpleFields} />
                </div>
                {multipleEmails && multipleEmails.length > 0 ? (
                    <div className="form-section allow-overflow">
                        <div>
                            <p className="label">Additional Emails</p>
                            <p className="user-text">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Email ID</th>
                                            <th>MSR Enabled</th>
                                            <th>MTR Enabled</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {multipleEmails?.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{item?.emailId}</td>
                                                    <td>
                                                        {item?.isMSR
                                                            ? 'True'
                                                            : 'False'}
                                                    </td>
                                                    <td>
                                                        {item?.isMTR
                                                            ? 'True'
                                                            : 'False'}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </p>
                        </div>
                    </div>
                ) : (
                    <></>
                )}
            </div>
        </>
    );
};

NotificationView.propTypes = {
    data: PropTypes.object,
};

export default NotificationView;
